
// eslint-disable-next-line import/prefer-default-export
export type AsyncOrSyncIterable<T> = AsyncIterable<T> | Iterable<T>;
